document.addEventListener('DOMContentLoaded', () => { 
  const targetSection = document.querySelector('.cb-list'); 
  if (targetSection) { 
    let isInView = false; 
    let lastScrollTop = 0; 
    const observer = new IntersectionObserver((entries, observer) => { 
      entries.forEach(entry => { 
        if (entry.isIntersecting) { 
          isInView = true; 
        } else { 
          isInView = false; 
        } 
      }); 
    }, { 
      root: null, 
      rootMargin: '0px 0px -50% 0px', 
      threshold: 0.8 
    }); 

    observer.observe(targetSection); 

    document.addEventListener('scroll', (e) => { 
      if (window.innerWidth >= 768 || targetSection.classList.contains('block-scroll') || !isInView) return; 
      let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop; 
      if (currentScrollTop > lastScrollTop) { 
        targetSection.scrollLeft += 4; 
      } else { 
        targetSection.scrollLeft -= 4; 
      } 
      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; 
    }); 

    targetSection.addEventListener('touchmove', () => { 
      targetSection.classList.add('block-scroll') 
    }); 
  }; 
});
